import { render, staticRenderFns } from "./ElSelectTable2.vue?vue&type=template&id=5e520f27&"
import script from "./ElSelectTable2.vue?vue&type=script&lang=js&"
export * from "./ElSelectTable2.vue?vue&type=script&lang=js&"
import style0 from "./ElSelectTable2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports